import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const UpsertPricingRecommendationsStatusDocument = gql`
  mutation UpsertPricingRecommendationsStatus(
    $actions: [PricingRecommendationActionInput!]!
  ) {
    upsertPricingRecommendationsStatusForBusinessOrganization(
      actions: $actions
    ) {
      accepted_count
      overridden_count
      rejected_count
    }
  }
`;
export type UpsertPricingRecommendationsStatusMutationFn =
  Apollo.MutationFunction<
    Types.UpsertPricingRecommendationsStatusMutation,
    Types.UpsertPricingRecommendationsStatusMutationVariables
  >;
export function useUpsertPricingRecommendationsStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpsertPricingRecommendationsStatusMutation,
    Types.UpsertPricingRecommendationsStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpsertPricingRecommendationsStatusMutation,
    Types.UpsertPricingRecommendationsStatusMutationVariables
  >(UpsertPricingRecommendationsStatusDocument, options);
}
export type UpsertPricingRecommendationsStatusMutationHookResult = ReturnType<
  typeof useUpsertPricingRecommendationsStatusMutation
>;
export type UpsertPricingRecommendationsStatusMutationResult =
  Apollo.MutationResult<Types.UpsertPricingRecommendationsStatusMutation>;
export type UpsertPricingRecommendationsStatusMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpsertPricingRecommendationsStatusMutation,
    Types.UpsertPricingRecommendationsStatusMutationVariables
  >;
